import { logout } from '../actions/auth.action';
import { openMessageError } from '../../components/common/Message/openMessageError';
import i18n from '../../languages/i18n';
import { parseJson } from '../../utils/string/parseJson';

// Helper function để lấy error message
const getErrorMessage = error => {
  const message = error.message || error?.data?.message;

  if (!message) return i18n.t('Error.unknown_error');

  // Nếu message là string
  if (typeof message === 'string') {
    // Thử parse JSON
    try {
      const parsed = parseJson(message);
      return typeof parsed === 'string' ? parsed : JSON.stringify(parsed);
    } catch {
      return message;
    }
  }

  // Nếu message là object
  if (typeof message === 'object') {
    return message.message || JSON.stringify(message);
  }

  return String(message);
};

// HTTP 403 của backend có hai nguồn: thiếu quyền (data.error.permission = { code, action }) và lỗi xác thực (data.error.header)
export const isPermissionError = error =>
  !!(error?.data?.error ?? error?.error)?.permission;

const errorMiddleware = store => {
  return next => async action => {
    if (action.type?.toLowerCase()?.includes('fail')) {
      const error = action.payload;
      if (error.status === 401) {
        openMessageError({
          content: i18n.t('Error.auth_error'),
          forced: true,
        });
        store.dispatch(logout());
      } else if (error.status === 403 && isPermissionError(error)) {
        // Thiếu quyền (error.permission): chỉ báo lỗi, không đăng xuất
        openMessageError({
          content: getErrorMessage(error),
        });
      } else if (error.status === 403) {
        // Token thiếu hoặc hết hạn (error.header): đăng xuất như cũ
        openMessageError({
          content: i18n.t('Error.forbidden_error'),
        });
        store.dispatch(logout());
      } else if (
        error.status === 500 ||
        error.status === 400 ||
        error.status === 404 ||
        error.code_status === 1400
      ) {
        openMessageError({
          content: getErrorMessage(error),
        });
      } else if (error.code_status === 1600) {
        openMessageError({
          content: error.message?.message || i18n.t('Error.unknown_error'),
        });
      } else if (error.status === 409) {
        openMessageError({ content: i18n.t('Error.too_many_requests') });
      } else if (error.success === false) {
        openMessageError({
          content: getErrorMessage(error),
        });
      }
    }
    return next(action);
  };
};

export default errorMiddleware;
